import React from 'react';
import { Col, Row, FormGroup } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { Form, PhoneBox } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'

class PhoneBoxDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				preset: "(555) 555-5555",
				phoneTypesPreset: {
					value: "(555) 555-5555",
                    type: "Cell",
                    extension: "444"
				},
				phoneTypesDisabled: {
					value: "(555) 555-5555",
					type: "Work"
				}
			}
		};
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	handleSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		const types = ["Work", "Home", "Cell"];

		return (
			<Box title="PhoneBox">
				<Form
					onChange={this.handleChange}
					values={this.state.form}
					onSubmit={this.handleSubmit}>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Default</Label>
								<PhoneBox name="default" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Placeholder</Label>
								<PhoneBox name="placeholder" placeholder="Enter your phone" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Disabled</Label>
								<PhoneBox name="disabled" disabled={true} />
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Preset</Label>
								<PhoneBox name="preset" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default" required>Required</Label>
								<PhoneBox name="required" required />
							</FormGroup>
						</Col>
						<Col md={4}>
						</Col>
					</Row>
					<Row>
						<Col md={6}>
							<FormGroup>
								<Label htmlFor="default">Phone Types</Label>
								<PhoneBox name="phoneTypes" types={types} />
							</FormGroup>
						</Col>
						<Col md={6}>
						<FormGroup>
								<Label htmlFor="default">Phone Types (Preset)</Label>
								<PhoneBox name="phoneTypesPreset" types={types} />
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col md={6}>
							<FormGroup>
								<Label htmlFor="default">Phone Types (Disabled)</Label>
								<PhoneBox name="phoneTypesDisabled" types={types} disabled />
							</FormGroup>
						</Col>
						<Col md={6}>
						<FormGroup>
								<Label htmlFor="default">Phone Types (Required)</Label>
								<PhoneBox name="phoneTypesRequired" types={types} required />
							</FormGroup>
						</Col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form>
			</Box>
		)
	}
}

export default PhoneBoxDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/PhoneBoxDemo.js